// extracted by mini-css-extract-plugin
export default {"OptionTitle":"ThreeDotsMenu_OptionTitle__rnlYh"};